import { create } from 'zustand'

import type { BusinessInfoType } from '../schemas/business-create'

type BusinessAdditionalInfoStore = {
  selectedInfoType: BusinessInfoType | null
  setSelectedInfoType: (infoType: BusinessInfoType | null) => void
}

const useBusinessAdditionalInfoStore = create<BusinessAdditionalInfoStore>((set) => ({
  selectedInfoType: null,
  setSelectedInfoType: (infoType) => set({ selectedInfoType: infoType }),
}))

export default useBusinessAdditionalInfoStore
